module.exports = __webpack_public_path__ + "img/code-branch.215f6a35.svg";